import {defineNuxtPlugin, useRoute} from '#imports';
import {useDataTracking} from '../composables/useDataTracking';

export default defineNuxtPlugin((nuxtApp) => {
    const route = useRoute();
    const {trackPageView} = useDataTracking();

    nuxtApp.hook('page:loading:end', () => {
        if (route.meta.trackPageView !== false) {
            trackPageView();
        }
    });
});
